<div class="CommonContainerCard border__radius8 m-top CommonBorderColor points-container" [ngClass]="((pointsForm.get('scrubberPoints')?.hasError('required')) && 
(pointsForm.get('scrubberPoints')?.touched || pointsForm.get('scrubberPoints')?.dirty))
 || pointsForm.get('scrubberPoints')?.hasError('pattern') ? 'changeHeight' : ''">
    <p class="sub-heading-s1 fleet-section-title pointsText">Points</p>
     <form [formGroup]="pointsForm" class="pointsForm">
        <div class="pointSection">
             <snl-input class="points-input-text" [label]="'Pool points'" [helperText]="searchText" [type]="'text'"
            formControlName="points" [ngClass]="(pointsForm.get('points')?.hasError('required') &&
             pointsForm.get('points')?.dirty )
            || pointsForm.get('points')?.hasError('pattern') ? 'displayErrmsg' : ''" 
            (focusout)="handleFocusOutPoints($event)">
            </snl-input>
            <div class="errorMsg pointsErr"  *ngIf=" pointsForm.get('points')?.dirty">
                <p *ngIf="pointsForm.get('points')?.hasError('required')">
                    Pool Points are required.
                </p>
                <p *ngIf="pointsForm.get('points')?.hasError('pattern')">
                Please enter a valid decimal input.
                </p>
            </div>
            <div class="errorMsg pointsErr"  *ngIf="showPointsErrorMsg && pointsForm.get('points')?.touched">
                <p *ngIf="pointsForm.get('points')?.hasError('required')">
                    Pool Points are required.
                </p>  
            </div>
        </div>
        <div class="scrubberSection" *ngIf="showScrubber">
            <snl-input class="points-input-text" [label]="'Scrubber points'" [helperText]="searchText" [type]="'text'"
            formControlName="scrubberPoints" (focusout)="handleFocusOutScrubber($event)" >
            </snl-input>
            <div class="errorMsg scrubberErr"  *ngIf=" pointsForm.get('scrubberPoints')?.dirty">
                <p *ngIf="pointsForm.get('scrubberPoints')?.hasError('required')">
                    Scrubber Points are required.
                </p>
                <p *ngIf="pointsForm.get('scrubberPoints')?.hasError('pattern')">
                Please enter a valid decimal input.
                </p>
            </div>
            <div class="errorMsg scrubberErr"  *ngIf=" showScrubberErrorMsg && pointsForm.get('scrubberPoints')?.touched">
                <p *ngIf="pointsForm.get('scrubberPoints')?.hasError('required')">
                    Scrubber Points are required.
                </p>
            
            </div>
        </div>
        
     </form>
    
</div>